import { Label } from "@/components/ui/label";

interface Props {
  id: string;
  label: string;
  error?: string | null;
  hint?: React.ReactNode;
  children: React.ReactNode;
}

// A labelled form control with an optional hint and validation message. The control
// itself should carry `id`, and `aria-describedby={describedBy(id)}` when it has either.
const Field: React.FC<Props> = ({ id, label, error, hint, children }) => (
  <div className="grid gap-2">
    <Label htmlFor={id}>{label}</Label>
    {children}
    {error ? (
      <p id={`${id}-message`} className="text-sm text-destructive">
        {error}
      </p>
    ) : hint ? (
      <p id={`${id}-message`} className="text-sm text-muted-foreground">
        {hint}
      </p>
    ) : null}
  </div>
);

export const describedBy = (id: string) => `${id}-message`;

export default Field;
